import { createRouter, createWebHistory } from 'vue-router'
import { redirectNotFound } from './middleware'

const routes = [
  {
    path: '/',
    beforeEnter: redirectNotFound,
    children: [
      {
        path: 'notfound',
        name: 'Notfound',
        component: () => import('@/views/NotFound.vue')
      },
      {
        path: 'cert',
        name: 'CertActive',
        component: () => import('@/views/CerActivate.vue')
      },
      {
        path: 'blank',
        name: 'Blank',
        component: () => import('@/views/blank.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
